import React from 'react';
import { Box, Typography, Button, Tooltip, CircularProgress } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import RefreshIcon from '@mui/icons-material/Refresh';

const SocketConnectionStatus = ({
    socketConnected,
    isReconnecting,
    reconnectAttempt,
    lastError,
    onManualReconnect,
    colors
}) => {
    const getStatusColor = () => {
        if (socketConnected) return 'success';
        if (isReconnecting) return 'warning';
        return 'error';
    };

    const getStatusText = () => {
        if (socketConnected) return 'Online';
        if (isReconnecting) return `Reconnecting... (${reconnectAttempt})`;
        return 'Disconnected';
    };

    return (
        <Tooltip title={lastError ? `Last error: ${lastError}` : ''} placement="bottom">
            <Box component="span" sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
                {isReconnecting ? (
                    <CircularProgress size={16} color="warning" />
                ) : (
                    <FiberManualRecordIcon fontSize='small' color={getStatusColor()} />
                )}
                <Typography
                    variant="h5"
                    sx={{
                        color: socketConnected
                            ? colors.primary[100]
                            : isReconnecting
                                ? '#ffc107'
                                : '#f44336'
                    }}
                >
                    {getStatusText()}
                </Typography>
                {!socketConnected && !isReconnecting && (
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<RefreshIcon />}
                        onClick={onManualReconnect}
                        sx={{ ml: 1 }}
                    >
                        Reconnect
                    </Button>
                )}
            </Box>
        </Tooltip>
    );
};

export default SocketConnectionStatus;
